import "@Styles/Shared/NativeAds/brandingHeader_sm.less";
import "@Styles/Shared/NativeAds/brandingHeader_md.less";
export default {
  methods: {
    init: function init() {},
    raiseEvent: function raiseEvent(eventType) {
      if (!eventType) {
        this.logMessage("Aborting raiseEvent because eventType is not defined");
        return;
      }

      var eventData = {
        EventType: eventType,
        ProgramCreativeType: "Branding Header"
      };
      this.logMessage("RaiseEvent: " + eventType);

      if (typeof GeneralMills.Analytics !== 'undefined') {
        GeneralMills.Analytics.raiseEvent(eventData);
      } else {
        this.logMessage("GeneralMills.Analytics is undefined.");
      }
    },
    logMessage: function logMessage(message) {
      if (!message || !window.console) {
        return;
      }

      window.console.log("[NativeAds - BrandingHeader] " + message);
    }
  }
};